import { TextItemSchema } from 'cms/schemaTypes/staticPages/objects/textItem'

import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import FormattedText from 'shared/ui/FormattedText'

import {
  PageTitle,
  SectionContainer,
  SectionContent
} from '../landings/styles'

import styles from './HeaderSection.module.scss'

interface HeaderSectionProps {
  header: string
  headerDescription: TextItemSchema
}

export default function HeaderSection({
  header,
  headerDescription
}: HeaderSectionProps) {
  return (
    <SectionContainer $condensed>
      <SectionContent $top={3} $topMobile={3} $bottom={16} $bottomMobile={8}>
        <PageTitle>
          <FormattedText text={header} />
        </PageTitle>
        <div className={styles.description}>
          <CustomPortableText value={headerDescription?.textField || []} />
        </div>
      </SectionContent>
    </SectionContainer>
  )
}
